import { InfoCard as AntdInfoCard } from "@empglabs/backoffice-ui-kit"

const InfoCard = props => {
  return <AntdInfoCard {...props} />
}

export default InfoCard
